<template>
  <div class="ExtensionSettings">
    <label>
      <span>Show captions in other browser tabs</span>
      <div>
        <select v-model="mode" :disabled="!installed">
          <option value="none">
            No window / off
          </option>
          <option value="self">
            This window
          </option>
          <option value="all">
            All windows
          </option>
          <option value="active">
            Active window
          </option>
          <option value="inactive">
            Inactive windows
          </option>
        </select>
      </div>
      <div v-if="!installed" class="info red">
        Textify web extension is not installed
      </div>
    </label>
  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'ExtensionSettings',
  components: {
    //Component
  },
  data: function () {
    return {
    }
  },
  props: {
  },
  computed: {
    ...mapState('extension',[
      'installed',
    ]),
    mode: {
      get () { return this.$store.state.extension.mode},
      set (value) {
        this.$store.dispatch('extension/sendMode',{mode: value})
      }
    },
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.ExtensionSettings{
}

.emojis{
  display: flex;
  flex-wrap: wrap;
}

.emoji{
  cursor: pointer;
  filter: grayscale(1);
}

.emoji.selected, .emoji:hover{
  filter: grayscale(0);
}

</style>
